<template>
	<article class="small-12 featureWidget flex vertical-align animated fadeIn">
        <div class="small-12 widget borderRadius8 border light">
            <div class="small-12 columns border-bottom rentBreakdown">
                <div class="small-12 columns totalRent flex vertical-align">
                    <p class="auto float-left" v-if="totalMonthlyRent > 0">${{ totalMonthlyRent | convertCentsToDollars}}</p>
                    <p class="auto float-left" v-else>$0.00</p>
                    <span class="auto float-left">Monthly Rent</span>
                </div>
                <ul class="small-12 columns flex vertical-align float-left" v-if="rent && rent.attributes.amount > 0">
                    <li class="auto">
                        <p>
                            <b v-if="rent.attributes.amount > 0">${{ rent.attributes.amount | convertCentsToDollars}}</b>
                            <b v-else>$0.00</b>
                            <span>Monthly Rent</span>
                        </p>
                    </li>
                    <li class="auto">
                        <span class="operator">+</span>
                    </li>
                    <li class="auto">
                        <p class="flex vertical-align">
                            <b v-if="rent.attributes.transaction_fees_policy.set_policy && rent.attributes.transaction_fees_policy.resident.fee_amount > 0">${{ rent.attributes.transaction_fees_policy.resident.fee_amount | convertCentsToDollars}}</b>
                            <b v-else>$0.00</b>
                            <span>Transaction Fee</span>
                        </p>
                    </li>
                    <li class="auto">
                        <span class="operator">=</span>
                    </li>
                    <li class="auto">
                        <p>
                            <b v-if="totalMonthlyRent > 0">${{ totalMonthlyRent | convertCentsToDollars}}</b>
                            <b v-else>$0.00</b>
                            <span>Total Monthly Rent</span>
                        </p>
                    </li>
                </ul>
                <ul class="small-12 columns flex vertical-align float-left" v-else>
                    <li class="auto">
                        <p>
                            <b>$0.00</b>
                            <span>Monthly Rent</span>
                        </p>
                    </li>
                    <li class="auto">
                        <span class="operator">+</span>
                    </li>
                    <li class="auto">
                        <p>
                            <b>$0.00</b>
                            <span>Transaction Fee</span>
                        </p>
                    </li>
                    <li class="auto">
                        <span class="operator">=</span>
                    </li>
                    <li class="auto">
                        <p>
                            <b>$0.00</b>
                            <span>Total Monthly Rent</span>
                        </p>
                    </li>
                </ul>
            </div>
			<div class="small-12 large-6 columns">
				<div class="small-12 large-5 occupancyChart">
					<div class="small-12 chartContainer">
						<div class="small-12 columns chart chart-line-xs" style="margin-top:10px;" v-if="balanceChartData && balanceChartOptions">
							<div class="small-12 wrap">
								<pie-chart :chartOptions="balanceChartOptions" :chartData="balanceChartData"></pie-chart>
							</div>
						</div>
					</div>
				</div>
				<div class="small-12 large-7 columns">
                    <div class="small-12">
                        <h4 class="small-12 text-overflow" v-if="rent && rent.metrics.total_paid_amount > 0">${{ rent.metrics.total_paid_amount | convertCentsToDollars }}</h4>
                        <h4 class="small-12 text-overflow" v-else>$0</h4>
                        <p class="small-12 text-overflow">Total Money In</p>
                    </div>
                    <div class="small-12" style="margin-top:15px;">
                        <h4 class="small-12 text-overflow" v-if="rent && rent.metrics.total_paid_amount > 0">${{ totalOutstanding | convertCentsToDollars }}</h4>
                        <h4 class="small-12 text-overflow" v-else>$0</h4>
                        <p class="small-12 text-overflow">Remaining Balance</p>
                    </div>
				</div>
			</div>
            <ul class="float-left small-12 large-6 columns flex detailList">
                <li class="small-12 border-bottom" style="padding-bottom:15px;">
                    <p class="flex vertical-align text-overflow small-12 large-6">
                        <b>Status:</b>
                        <span class="badge bgPurple borderRadius4" v-if="!rent">Not Active</span>
						<span class="badge bgRed borderRadius4" v-else-if="rent && rent.attributes.term == 'late'">Late</span>
						<span class="badge bgPrimaryBlue borderRadius4" v-else>Current</span>
                    </p>
                    <p class="flex vertical-align text-overflow small-12 large-6" v-if="lease && lease.type == 'fixed_rollover'">
                        <b>Type:</b>
                        Fixed w/ Rollover
                    </p>
					<p class="flex vertical-align text-overflow small-12 large-6" v-else-if="lease && lease.type == 'fixed'">
                        <b>Type:</b>
                        Fixed
                    </p>
					<p class="flex vertical-align text-overflow small-12 large-6" v-else-if="lease && lease.type == 'at_will'">
                        <b>Type:</b>
                        At Will
                    </p>
					<p class="flex vertical-align text-overflow small-12 large-6" v-else-if="lease && lease.type == 'month_to_month'">
                        <b>Type:</b>
                        Month to Month
                    </p>
                </li>
                <li class="small-12 border-bottom" style="padding-bottom:15px;">
                    <p class="small-12 large-6 flex vertical-align text-overflow" v-if="rent">
                        <b class="small-12">Start Date:</b>
                        {{ rent.attributes.term_dates.starting_at | unixToDate }}
                    </p>
					<p class="small-12 large-6 flex vertical-align text-overflow" v-else-if="lease">
                        <b class="small-12">Start Date:</b>
                        {{ lease.attributes.details.start_date | unixToDate }}
                    </p>
					<p class="small-12 large-6 flex vertical-align text-overflow" v-else>
                        <b class="small-12">Start Date:</b>
                        --
                    </p>
                    <p class="small-12 large-6 flex vertical-align text-overflow" v-if="rent">
                        <b class="small-12">End Date:</b>
                        {{ rent.attributes.term_dates.ending_at | unixToDate }}
                    </p>
					<p class="small-12 large-6 flex vertical-align text-overflow" v-else-if="lease">
                        <b class="small-12">End Date:</b>
                        {{ lease.attributes.details.end_date | unixToDate }}
                    </p>
					<p class="small-12 large-6 flex vertical-align text-overflow" v-else>
                        <b class="small-12">End Date:</b>
                        --
                    </p>
                </li>
                <li class="small-12">
                    <p class="small-12 flex vertical-align text-overflow" v-if="lease && lease.attributes.renewal.notice_date">
                        <b class="small-12">Renewal Notice Set For:</b>
						{{ lease.attributes.renewal.notice_date | unixToDate }}
                    </p>
					<p class="small-12 flex vertical-align text-overflow" v-else>
                        <b class="small-12">Renewal Notice Set For:</b>
						--
                    </p>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>

	// Import the filters
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'

	// Import the components
    import PieChart from '@/components/framework/charts/PieChart.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LeaseStats',

		/*
		**  Register the components
		*/

		components: {

			PieChart

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			DatesFilters,
			MoneyConversions

		],

		/*
		**  Set the props
		*/

		props: {

			rent: {
				type: Object,
				default: () => null
			},

			lease: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			balanceChartOptions: null,
            balanceChartSeries: [],
            balanceChartData: null

		}),

		/*
		**  Watch em'
		*/

		watch: {

			rent: {

				immediate: true, // Load on created
				handler(rent) {

					/*
					**  Set the chart
					**  @method: @here
					*/

					if (rent && rent.metrics.total_paid > 0) this.setBalanceChart();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	/*
            **  Set the chart options
            **  @method: @here
            */

            this.setBalanceChartOptions();

            /*
            **  Set the empty chart
            **  @method: @here
            */

            this.setEmptyBalanceChart();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			setEmptyBalanceChart: function() {

                try {

                    /*
                    **  Populate the chart data
                    **  @method: @here
                    */

                    this.balanceChartData = {

                        labels: ['Money In', 'Remaining'],
                        datasets: [
                            {
                                backgroundColor: ['#d0d1d2'],
                                borderColor: '#ffffff',
                                data: [100, 0]
                            }
                        ]

                    };

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the empty balance chart.',
						errorType: 'Application',
						section: 'Rent',
                        uid: 'Ty23n9xaAofymqBL4InP',
						error: e
					});

                }

            },

			setBalanceChartOptions: function() {

                try {

                    /*
                    **  Populate the options
                    **  @prop: @here
                    */

                    this.balanceChartOptions = {
                        responsive: true, 
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                            position: 'right'
                        },
                        tooltips: {
                            enabled: false,
                        },
                        cutoutPercentage: 70
                    }

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the balance chart options.',
						errorType: 'Application',
						section: 'Rent',
                        uid: 'BUkE35sVJ3h2VXgwJ68w',
						error: e
					});

                }

            },

            setBalanceChart: function() {

                try {

                    /*
                    **  Set the variables
                    **  @method: @here
                    */

                    let paid_percent = 0,
                        not_paid_percent = 0;

                    /*
                    **  Calculate paid vs remaining percentages
                    **  @method: @here
                    */

				    if (this.rent.metrics.total_paid_amount > 0) {

                        paid_percent = ((this.rent.metrics.total_paid_amount / this.rent.metrics.total_balance) * 100).toFixed(0);
                        not_paid_percent = 100 - paid_percent;

                    }

                    /*
                    **  Set the series data
                    **  @method: @here
                    */

                    this.balanceChartSeries.push(Number(paid_percent), not_paid_percent);

                    /*
                    **  Populate the chart data
                    **  @method: @here
                    */

                    this.balanceChartData = {

                        labels: ['Money In', 'Remaining'],
                        datasets: [
                            {
                                backgroundColor: ['#44c6f6', '#3d2f9e'],
                                borderColor: '#ffffff',
                                data: this.balanceChartSeries
                            }
                        ]

                    };

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the balance chart.',
						errorType: 'Application',
						section: 'Rent',
                        uid: 'lVGTABN0ZJWIBCBpWLGG',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			totalOutstanding: function() {

                return this.rent.metrics.total_balance - this.rent.metrics.total_paid_amount;

            },

            totalMonthlyRent: function() {

                if (this.rent) {

                    /*
                    **  Set the base rent amount
                    */

                    let amount = this.rent.attributes.amount;

                    /*
                    **  Add a transaction fee, if applicable
                    */

                    if (this.rent.attributes.transaction_fees_policy.set_policy && this.rent.attributes.transaction_fees_policy.resident.fee_amount > 0) {

                        amount = amount + this.rent.attributes.transaction_fees_policy.resident.fee_amount;

                    }

                    return amount;

                }

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>